import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConservationActionCard = ({ action }) => {
  const getStatusColor = (status) => {
    const colors = {
      'Active': 'bg-success text-success-foreground',
      'Planning': 'bg-info text-info-foreground',
      'Completed': 'bg-muted text-muted-foreground',
      'Urgent': 'bg-error text-error-foreground'
    };
    return colors?.[status] || colors?.Planning;
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="bg-primary text-primary-foreground rounded-full p-3">
            <Icon name={action?.icon} size={24} />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">{action?.title}</h3>
            <p className="text-sm text-muted-foreground">{action?.targetSpecies}</p>
          </div>
        </div>
        <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(action?.status)}`}>
          {action?.status}
        </span>
      </div>
      <p className="text-sm text-muted-foreground mb-4">{action?.description}</p>
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Start Date</p>
          <p className="text-sm font-medium text-foreground">{action?.startDate}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Duration</p>
          <p className="text-sm font-medium text-foreground">{action?.duration}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Budget</p>
          <p className="text-sm font-medium text-foreground">{action?.budget}</p>
        </div>
      </div>
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-muted-foreground">Progress</span>
          <span className="text-xs font-medium text-foreground">{action?.progress}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className="bg-success h-2 rounded-full animation-organic"
            style={{ width: `${action?.progress}%` }}
          />
        </div>
      </div>
      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Users" size={16} />
          <span>{action?.teamSize} researchers</span>
        </div>
        <Button variant="outline" size="sm" iconName="ExternalLink" iconPosition="right">
          View Details
        </Button>
      </div>
    </div>
  );
};

export default ConservationActionCard;